import { render, staticRenderFns } from "./member-management.vue?vue&type=template&id=360fb50a&"
import script from "./member-management.vue?vue&type=script&lang=js&"
export * from "./member-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports